import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { APIConstants } from '../../common';
import { ICreateOrderResponse, IPaymentPlanDetails, IPlanDetails, IVerifyPaymentResponse } from '../../models';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RazorpayService {


  private razorpayKey = 'rzp_test_s37W6P23XD7TAV';

  constructor(private http: HttpClient) { }

  createOrder(orderDetails: IPlanDetails): Observable<ICreateOrderResponse> {
    return this.http.post<ICreateOrderResponse>(APIConstants.createPaymentOrder, orderDetails);
  }

  verifyPayment(paymentResponse: IPaymentPlanDetails): Observable<IVerifyPaymentResponse> {
    return this.http.post<IVerifyPaymentResponse>(APIConstants.verifyPayment, paymentResponse);
  }

}
